import React, { useCallback } from 'react';
import { useDataMonitorStore } from '../pagehooks/useDataMonitorStore';

const DataMonitorFacilitySelect = (): JSX.Element => {
    const { facilityVal, facilityOptions, setFacility } = useDataMonitorStore();

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>): void => {
            setFacility(e.target.value);
        },
        [setFacility],
    );

    return (
        <div className="datamonitor-facility-select">
            <label>Facilities:</label>
            <select
                value={facilityVal}
                onChange={handleChange}
            >
                {facilityOptions.map((opt, idx) => (
                    <option
                        key={idx}
                        value={String(opt.val)}
                    >
                        {opt.lbl}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default DataMonitorFacilitySelect;
